import { useState, forwardRef, useRef, useImperativeHandle } from 'react';
import './style.css';
import { UploadCloudIcon } from '../../icons/upload-cloud-icon';

export const DragDropFile = forwardRef((props, ref) => {
    const { onFileChange, multiple, disabled, parentId } = props;
    const [dragActive, setDragActive] = useState(false);
    const inputRef = useRef(null);

    useImperativeHandle(ref, () => ({
        uploadFile() {
            inputRef.current.click();
        },
    }));

    const handleDrag = function (event) {
        if (event.type === 'dragenter' || event.type === 'dragover') {
            setDragActive(true);
        } else if (event.type === 'dragleave') {
            setDragActive(false);
            event.preventDefault();
            event.stopPropagation();
        }
    };

    const handleDrop = function (e) {
        e.preventDefault();
        e.stopPropagation();
        setDragActive(false);
        if (e.dataTransfer.files && e.dataTransfer.files[0] && !disabled) {
            // at least one file has been dropped so do something
            onFileChange(e.dataTransfer.files);
        }
    };

    const handleChange = function (e) {
        e.preventDefault();
        if (e.target.files && e.target.files[0]) {
            // at least one file has been selected so do something
            // handleFiles(e.target.files);
            onFileChange(e.target.files);
            inputRef.current.value = '';
        }
    };

    const handleDropFileClick = () => {
        document.querySelector('#input-file-upload')?.click();
    };

    return (
        <div id="form-file-upload" onDragEnter={handleDrag} style={{ cursor: 'pointer' }}>
            <input disabled={disabled} ref={inputRef} class={'input-file-upload'} type="file" id={'input-file-upload-' + parentId} multiple={multiple ? true : false} onChange={handleChange} />
            <label id="label-file-upload" htmlFor={'input-file-upload-' + parentId} className={dragActive ? 'drag-active' : ''}>
                <UploadCloudIcon />
                <div className="text">
                    <p>Browse and choose the files you want to upload.</p>
                    {/* <p>Drag and drop your file here </p>
                    <p>Or click in the container</p> */}
                    {/* <button className="upload-button">Or, Click here</button> */}
                </div>
            </label>
            {dragActive && !disabled && <div id="drag-file-element" onDragEnter={handleDrag} onDragLeave={handleDrag} onDragOver={handleDrag} onDrop={handleDrop}></div>}
        </div>
    );
});
